<template>
</template>

<script>
    import StreetViewControl from '@/libraries/ol/StreetView/StreetViewControl';
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    import { MAP_ACTIONS } from '@config/constants';

    let sv = null;
    export default {
        mixins: [
            ButtonControlMixin
        ],
        props: {
            showInfoNoGoogle: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                idPanel: 'streetview',
                className: 'ol-streetview',
            }
        },
        methods: {
            addButtonMap: function(_map){
                if(!this.isStreetviewAvailable()){
                    if(this.showInfoNoGoogle){
                        this.noGoogle();
                    }
                    return false;
                }

                let panel = _map.getPanel(this.posBtnMap);
                if(panel) {
                    let target = panel.element;
                    let content = _map.createHtmlBtnImg(this.title, null, this.assetsPathTheme('/map/streetview.svg'));
                    let ctrl = new StreetViewControl({
                        map: _map.getOLMap(),
                        update: true,  // sincronize map position
                        className: _map.getControlClassName(this.orderClassName),
                        content: content,
                        target: target,
                        onNoValidLocalion: () => {
                            this.onNoValidLocalion();
                        },
                        onBeforeOpen: () => {
                            this.onBeforeOpen();
                        },
                        onClosed: () => {
                            this.onClosed();
                        },
                        onToggle: (flag, sv) => {
                            this.onToggle(flag, sv);
                        },
                    });
                    _map.addControlOL(ctrl);
                    this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', (evt)=>{
                        let el = $(ctrl.element); if(el) el.hide()
                    });
                    this.$eventBus.listen(this.moduleCode, 'map.new-feature-finished', (evt)=>{
                        let el = $(ctrl.element); if(el) el.show()
                    });
                    return ctrl;
                }
                return false;
            },
            setAction(action) {
                this.$store.dispatch(`setActionMap`, {module: this.moduleCode, action});
            },
            isStreetviewAvailable: function() {
                return (typeof google === 'object'
                        && typeof google.maps === 'object'
                            && typeof google.maps.StreetViewService === 'function');
            },
            noGoogle: function() {
                this.showWarning(this.$t(`${this.idPanel}.info.noGoogleAvailable`), this.title);
            },
            onNoValidLocalion: function() {
                this.showWarning(this.$t(`${this.idPanel}.info.onValidLocalion`), this.title);
            },
            onToggle: function(flag, ctrl) {
                sv = ctrl;
                if(flag){
                    this.setAction(MAP_ACTIONS.STREET_VIEW);
                    this.addListener();
                }else{
                    this.setAction(null);
                    this.removeListener();
                }
            },
            onBeforeOpen: function() {
                this.showMessage(this.$t(`${this.idPanel}.info.onOpen`), this.title);
                this.$eventBus.publish(this.moduleCode, 'map.start-street-view-panorama');
            },
            onClosed: function() {
                this.clearMessages();
                this.setAction(null);
                this.removeListener();
                this.$eventBus.publish(this.moduleCode, 'map.end-street-view-panorama');
            },
            addListener: function(){
                document.addEventListener('keydown', this.escapeHandler);
            },
            removeListener: function(){
                document.removeEventListener('keydown', this.escapeHandler);
            },
            escapeHandler: function(evt){
                if(evt instanceof KeyboardEvent) {
                    if (evt.key === 'Escape') {
                        if(sv){
                            sv.forceClose();
                        }
                    }
                }
            },
        }
    }
</script>

<style lang="scss">
.cursor-sv {
    cursor: url('../../../libraries/ol/StreetView/img/street_view_cursor.gif') 7.5 17.5, crosshair;
}
</style>
